import { NutriscoreBadge } from '../../components/nutriscore-badge';
import type { Product } from '../../api/types';

interface ProductCardGridProps {
  products: Product[];
  onSelect: (barcode: string) => void;
}

/**
 * Grid of product cards as an alternative to the table view.
 * Each card shows image, name, brand, nutriscore, and scan count.
 */
export function ProductCardGrid({ products, onSelect }: ProductCardGridProps) {
  return (
    <div class="product-card-grid">
      {products.map((p) => (
        <div
          key={p.barcode}
          class="product-card"
          onClick={() => onSelect(p.barcode)}
        >
          {p.image_url ? (
            <img
              class="product-card-image"
              src={p.image_url}
              alt={p.name ?? p.barcode}
              loading="lazy"
            />
          ) : (
            <div
              class="product-card-image"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'var(--text-tertiary)',
                fontSize: '0.72rem',
              }}
            >
              No image
            </div>
          )}
          <div class="product-card-name" title={p.name ?? p.barcode}>
            {p.name ?? p.barcode}
          </div>
          {p.brand && (
            <div style={{ fontSize: '0.76rem', color: 'var(--text-secondary)', marginBottom: 'var(--sp-1)' }}>
              {p.brand}
            </div>
          )}
          <div class="product-card-barcode">{p.barcode}</div>
          <div class="product-card-meta">
            <NutriscoreBadge grade={p.nutriscore_grade} />
            <span style={{ fontSize: '0.72rem', color: 'var(--text-tertiary)' }}>
              {p.scan_count} scan{p.scan_count !== 1 ? 's' : ''}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}
